<template>
  <page-view title="出库审核列表">
    <template slot="action">
    </template>
    <expert-s-table ref="expertSTable" :fromType="ExpertFromType.STOCK_OUT"/>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import expertSTable from '@/epp/expertmain/expertInfo/common/ExpertSTable.vue'
import { ExpertFromType } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'

export default {
  name: 'ExpertStockOut',
  computed: {
    ExpertFromType () {
      return ExpertFromType
    }
  },
  components: {
    PageView,
    expertSTable,
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.ant-calendar-picker {
  width: 47% !important;
}
</style>
